import { AttachmentUpdatePayload } from 'aos-services/src/services/attachments/types/AttachmentUpdatePayload'
import {
    isImage,
    UploadedAttachment,
} from 'aos-services/src/services/attachments/types/UploadedAttachment'
import React, { FCWithChildren, useCallback } from 'react'
import { useKey } from 'react-use'

import { PreviewEditBox } from './PreviewEditBox'
import { PreviewViewBox } from './PreviewViewBox'

interface PreviewBoxProps {
    attachments: UploadedAttachment[]
    attachmentIndex: number
    editable: boolean
    updateAttachment?(v: AttachmentUpdatePayload): void
    onIndexChange(v: number): void
    close(): void
}

export const PreviewBox: FCWithChildren<PreviewBoxProps> = props => {
    const { editable, attachments, attachmentIndex, close, onIndexChange, updateAttachment } = props
    const attachment = attachments[attachmentIndex]
    const displayAsEdit = editable && isImage(attachment)
    const count = attachments.length

    const onPrev = useCallback(() => {
        if (attachmentIndex > 0) {
            onIndexChange(attachmentIndex - 1)
        }
    }, [attachmentIndex, onIndexChange])

    const onNext = useCallback(() => {
        if (attachmentIndex < count - 1) {
            onIndexChange(attachmentIndex + 1)
        }
    }, [attachmentIndex, count, onIndexChange])

    useKey('ArrowLeft', onPrev, {}, [onPrev])
    useKey('ArrowRight', onNext, {}, [onNext])

    const navProps = {
        count,
        activeIndex: attachmentIndex,
        onPrev,
        onNext,
        onDotPress: onIndexChange,
        close,
    }

    return displayAsEdit ? (
        <PreviewEditBox attachment={attachment} updateAttachment={updateAttachment} {...navProps} />
    ) : (
        <PreviewViewBox attachment={attachment} {...navProps} />
    )
}
